export default "__VITE_ASSET__e59a0bd3__"